import { useSetAtom } from 'jotai'
import { dictionaryState } from '../stores/dictionary.store'
import { useTransition } from 'react'
import { dictionaryApi } from '../services/dictionary.apis'
import { isEmpty } from 'lodash'

export function useDictionary() {
    const [isPending, startTransition] = useTransition()
    const setDictionary = useSetAtom(dictionaryState)

    const getDictionary = ({ countryCode, web }: { countryCode: string; web: string }) => {
        startTransition(async () => {
            try {
                const response = await dictionaryApi.getDictionary({ countryCode, web })
                if (!isEmpty(response.data)) {
                    setDictionary(response.data)
                } else {
                    setDictionary({
                        en: {}
                    })
                }
            } catch (error) {
                console.error('Failed to fetch dictionary:', error)
            }
        })
    }

    return {
        getDictionary,
        isPending
    }
}
